import React, { Component } from 'react'
import Link from '../utils/link'

class Footer extends Component {

  render() {

    return (
      <section className='footer'>
        <div className='footer__inner'>
          <div className='footer__col'>
            <ul>
              <li><Link to='tel:+61411839767'>Phone: +61 411 839 767</Link></li>
              <li><Link to='mailto:studio@emilygillis.com.au'>Email: studio@emilygillis.com.au</Link></li>
            </ul>
          </div>
          <div className='footer__col'>
            <ul>
              <li>© Emily Gillis {new Date().getFullYear()}</li>
            </ul>
          </div>
        </div>
      </section>
    )
	}
}

export default Footer